<template>
  <div v-if="showCloseButton" class="variable-list-with-close">
    <button
      type="button"
      class="variable-list-with-close__close"
      aria-label="Close"
      @click="$emit('close')"
    >
      <fluent-icon icon="dismiss" size="16" />
    </button>
    <mention-box :items="items" @mention-select="handleVariableClick">
      <template slot-scope="{ item }">
        <span class="text-capitalize variable--list-label">
          {{ item.description }}
        </span>
        ({{ item.label }})
      </template>
    </mention-box>
  </div>
  <mention-box
    v-else
    :items="items"
    @mention-select="handleVariableClick"
  >
    <template slot-scope="{ item }">
      <span class="text-capitalize variable--list-label">
        {{ item.description }}
      </span>
      ({{ item.label }})
    </template>
  </mention-box>
</template>

<script>
import { mapGetters } from 'vuex';
import { MESSAGE_VARIABLES } from 'shared/constants/messages';
import { buildMessageVariableOptions } from 'dashboard/helper/messageVariableOptions';
import MentionBox from '../mentions/MentionBox.vue';

export default {
  components: { MentionBox },
  props: {
    searchKey: {
      type: String,
      default: '',
    },
    /** Optional: array of { key, label } for custom variables (e.g. email template variables). If not set, uses MESSAGE_VARIABLES. */
    variableOptions: {
      type: Array,
      default: null,
    },
    /** When true, append contact custom attribute variables from the account store. */
    includeContactCustomAttributes: {
      type: Boolean,
      default: true,
    },
    /** When true, show a close button that emits 'close' when clicked. */
    showCloseButton: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      contactCustomAttributes: 'attributes/getAttributesByModel',
    }),
    sourceVariables() {
      if (this.variableOptions && this.variableOptions.length) {
        return this.variableOptions.map(({ key, label }) => ({ key, label }));
      }

      if (this.includeContactCustomAttributes) {
        return buildMessageVariableOptions(
          this.contactCustomAttributes('contact_attribute') || []
        );
      }

      return MESSAGE_VARIABLES;
    },
    items() {
      return this.sourceVariables
        .filter(
          variable =>
            variable.label.includes(this.searchKey) ||
            variable.key.includes(this.searchKey)
        )
        .map(variable => ({
          label: variable.key,
          key: variable.key,
          description: variable.label,
        }));
    },
  },
  methods: {
    handleVariableClick(item = {}) {
      this.$emit('click', item.key);
    },
  },
};
</script>
<style scoped lang="scss">
.variable-list-with-close {
  position: relative;

  &__close {
    @apply absolute top-1 right-1 z-10 p-1 rounded text-slate-500 hover:text-slate-700 hover:bg-slate-100 dark:text-slate-400 dark:hover:text-slate-200 dark:hover:bg-slate-700 border-0 cursor-pointer;
  }
}

.variable--list-label {
  font-weight: var(--font-weight-bold);
}
</style>
